




















import Vue from 'vue';
/* eslint-disable no-bitwise, @typescript-eslint/no-explicit-any */
export default Vue.extend({
  data() {
    return {
      message: null,
      title: null,
      options: {
        type: 'success',
        duration: 2000,
        permanent: false,
      },
      items: [] as any[],
      idx: 0,
    };
  },
  methods: {
    createUUID() {
      const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      return pattern.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    addItem(type: string, message: string, title: string, options: {}) {
      const defaultOptions = {
        type,
        duration: this.options.duration,
        permanent: this.options.permanent,
      };
      const itemOptions = { ...defaultOptions, ...options };

      const idx = this.createUUID();
      const newItem = {
        id: idx,
        message,
        title,
        options: itemOptions,
      };

      this.items.push(newItem);

      if (itemOptions.permanent === false) {
        setTimeout(() => {
          this.removeItem(idx);
        }, itemOptions.duration);
      }
    },
    removeItem(uid: string) {
      this.items = Object.assign(
        [],
        this.items.filter((x) => x.id !== uid),
      );
    },
    removeAll() {
      this.items = [];
    },
  },
});
